import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=36c842de&"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js&"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c842de')) {
      api.createRecord('36c842de', component.options)
    } else {
      api.reload('36c842de', component.options)
    }
    module.hot.accept("./ButtonSubmit.vue?vue&type=template&id=36c842de&", function () {
      api.rerender('36c842de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/ButtonSubmit.vue"
export default component.exports